import * as React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { FooterSocialLinks, SocialSectionDataProps } from './FooterSocialLinks';
import { FooterMobileStores, FooterMobileStoresBaseProps } from './FooterMobileStores';
import { generateSeparatorSections } from '../footer.utils';
import { MEDIA_BREAKPOINTS } from '../../../../../mediaQueries.const';

interface AdditionalFooterSectionsProps {
    socialSection: SocialSectionDataProps | null,
    appsSection: FooterMobileStoresBaseProps | null,
    separatorColor: string
}

const getSeparatorStyle = (borderTopColor: string) => {
  return StyleSheet.create({
    style: {
      height: '1px',
      width: '100%',
      backgroundColor: borderTopColor,
      [MEDIA_BREAKPOINTS.X_LARGE]: {
        display: 'none',
      },
      [MEDIA_BREAKPOINTS.LARGE]: {
        display: 'none',
      },
      [MEDIA_BREAKPOINTS.MEDIUM]: {
        display: 'block',
      },
      [MEDIA_BREAKPOINTS.SMALL]: {
        display: 'block',
      },
    },
  });
};

const getWrapperStyle = (numberOfSections: number) => {
  return StyleSheet.create({
    style: {
      display: 'grid',
      [MEDIA_BREAKPOINTS.X_LARGE]: {
        gridTemplateColumns: `repeat(${numberOfSections}, 1fr)`,
        justifyItems: 'center',
      },
      [MEDIA_BREAKPOINTS.LARGE]: {
        gridTemplateColumns: `repeat(${numberOfSections}, 1fr)`,
        justifyItems: 'center',
      },
      [MEDIA_BREAKPOINTS.MEDIUM]: {
        gridTemplateColumns: '1fr',
      },
      [MEDIA_BREAKPOINTS.SMALL]: {
        gridTemplateColumns: '1fr',
      },
    },
  });
};

const getSocialSection = (socialSection:SocialSectionDataProps | null) => {
  return socialSection ? <FooterSocialLinks key="social-links" {...socialSection as SocialSectionDataProps} /> : null;
};

const getAppsSection = (appsSection: FooterMobileStoresBaseProps | null) => {
  return appsSection ? <FooterMobileStores key="mobile-links" {...appsSection as FooterMobileStoresBaseProps} /> : null;
};

export const AdditionalFooterSections: React.FunctionComponent<AdditionalFooterSectionsProps> = props => {
  const { socialSection, appsSection, separatorColor } = props;
  const additionalFooterSections = [
    getSocialSection(socialSection),
    getAppsSection(appsSection),
  ].filter(section => section !== null);

  return additionalFooterSections.length === 0 ? null
    : (
      <div className={css(getWrapperStyle(additionalFooterSections.length).style)}>
        {additionalFooterSections.reduce(generateSeparatorSections(getSeparatorStyle(separatorColor).style), [])}
      </div>
    );
};
